import React, { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Sheet } from "@/pages/Familia";
import { useData } from "@/context/DataContext";
import { formatApiErrorDetail } from "@/lib/api";
import { nombrePropuesto } from "@/lib/nombres";

export const RenombrarSheet = ({ doc, onClose }) => {
  const { renombrarDocumento } = useData();
  const [nombre, setNombre] = useState(doc.filename || "");
  const [busy, setBusy] = useState(false);
  const sug = nombrePropuesto(doc);
  const guardar = async () => {
    if (!nombre.trim()) return toast.error("El nombre no puede estar vacío.");
    setBusy(true);
    try {
      await renombrarDocumento(doc.id, nombre.trim());
      toast.success("Nombre cambiado", { description: nombre.trim() });
      onClose();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo cambiar el nombre.");
      setBusy(false);
    }
  };
  return (
    <Sheet onClose={onClose} testid="renombrar-sheet">
      <h2 className="font-heading text-xl font-bold text-[#1C2421] pr-12">Cambiar nombre</h2>
      <input data-testid="renombrar-input" value={nombre} maxLength={150} onChange={(e) => setNombre(e.target.value)} autoFocus
        className="mt-5 w-full min-h-[52px] px-4 rounded-xl bg-white border border-[#E5DFD5] text-base text-[#1C2421] focus:outline-none focus:ring-4 focus:ring-[#3A6B56]/20 focus:border-[#3A6B56]" />
      {doc.original_filename && (
        <p data-testid="renombrar-original" className="text-xs text-[#9AA39D] mt-1.5 break-all">Archivo original: {doc.original_filename}</p>
      )}
      {sug && sug !== nombre && (
        <button data-testid="renombrar-usar-sugerido" onClick={() => setNombre(sug)}
          className="mt-4 w-full text-left bg-[#E8F0EC] border border-[#3A6B56]/30 rounded-xl px-4 py-3 flex items-start gap-2">
          <Sparkles size={18} className="text-[#3A6B56] shrink-0 mt-0.5" />
          <span className="text-base text-[#1C2421]">Usar nombre sugerido: <strong>{sug}</strong></span>
        </button>
      )}
      <div className="flex gap-2.5 mt-6">
        <button onClick={onClose} className="flex-1 min-h-[52px] rounded-xl bg-[#F2EDE4] font-semibold text-base border border-[#E5DFD5]">Cancelar</button>
        <button data-testid="renombrar-guardar" onClick={guardar} disabled={busy || !nombre.trim()}
          className="flex-1 min-h-[52px] rounded-xl bg-[#3A6B56] text-white font-semibold text-base disabled:opacity-50">{busy ? "Guardando…" : "Guardar"}</button>
      </div>
    </Sheet>
  );
};
